// Versão: 1.01
// Data..: 2026-10-13
// Preferências de notificação do usuário (por navegador, via localStorage):
// som ligado/desligado, som escolhido, volume e notificação nativa do sistema.
// v1.01: adiciona o volume (0..1) do alerta sonoro.

import type { SoundId } from './sounds.js';

export interface NotificationPrefs {
  soundEnabled: boolean;
  sound: SoundId;
  volume: number; // volume do alerta sonoro (0..1)
  desktopEnabled: boolean;
}

const STORAGE_KEY = 'makweb.notifications.prefs';

const DEFAULTS: NotificationPrefs = {
  soundEnabled: true,
  sound: 'chime',
  volume: 0.6, // volume padrão do alerta (0..1)
  desktopEnabled: true,
};

// Lê as preferências salvas, mesclando com os padrões (tolerante a dados antigos).
export function loadPrefs(): NotificationPrefs {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULTS };
    return { ...DEFAULTS, ...(JSON.parse(raw) as Partial<NotificationPrefs>) };
  } catch {
    return { ...DEFAULTS };
  }
}

// Persiste as preferências e avisa a aplicação (evento para atualizar em tempo real).
export function savePrefs(prefs: NotificationPrefs): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    window.dispatchEvent(new CustomEvent('makweb:notif-prefs', { detail: prefs }));
  } catch {
    // sem localStorage (modo privado): ignora
  }
}
